import {AbstractModel} from "./abstract-model";

export class Document extends AbstractModel {
  id: number | null = null;
  createdAt: Date | null = null;
  type: string | null = null;
  filename: string | null = null;
  url: string | null = null;

  isPdf(): boolean {
    return this.type === 'application/pdf';
  }

  isImage(): boolean {
    return this.type?.startsWith('image/') ?? false;
  }
}
